import { Form, useForm } from 'react-hook-form';

import { FormTextarea } from '~components/Forms/Textarea';
import { ButtonPrimary, RatingField } from '~shared/ui/molecules';
import { FormGrid } from '~theme/snippets';

import { Action } from './style';
import type { FeedbackFormValues } from './types';

type Props = {
	isLoading: boolean;
	onSubmit: (values: FeedbackFormValues) => Promise<void>;
};

export const FeedbackForm = ({ isLoading, onSubmit }: Props) => {
	const {
		control,
		register,
		formState: { errors, isSubmitting, isValid, dirtyFields },
		handleSubmit,
		watch,
	} = useForm<FeedbackFormValues>({
		mode: 'onChange',
		reValidateMode: 'onChange',
	});

	const ratingValue = watch('rating');

	const isDirtyAlt = !!Object.keys(dirtyFields).length;

	return (
		<Form className={FormGrid} control={control}>
			<RatingField<FeedbackFormValues>
				name="rating"
				register={register}
				disabled={isSubmitting}
				rules={{ required: 'Field cannot be empty' }}
				error={errors?.rating}
			/>

			{ratingValue && (
				<FormTextarea<FeedbackFormValues>
					className={ratingValue ? '' : 'hidden'}
					name="feedback"
					register={register}
					label="Feedback"
					placeholder="Your feedback"
					disabled={isSubmitting || isLoading}
					width={100}
					rules={{
						minLength: 0,
						maxLength: {
							value: 200,
							message: 'Maximum characters limit reached',
						},
					}}
					error={errors.feedback}
					rows={4}
				/>
			)}

			<Action>
				<ButtonPrimary
					text="Submit"
					width={280}
					disabled={!isDirtyAlt || !isValid}
					loading={isSubmitting || isLoading}
					onClick={handleSubmit(onSubmit)}
				/>
			</Action>
		</Form>
	);
};
